import React from "react";
import ProductoPromocion from "../components/products/ProductoPromocion";

const Promocion = () => {
  return <ProductoPromocion />;
};

export default Promocion;
